module.exports = __webpack_public_path__ + "static/img/gws_hardik.3947b6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws_hardik.jpg
// module id = B7nV
// module chunks = 1